import React from 'react';

import AllBreakoutRoomsView from '../components/allBreakoutRooms/AllBreakoutRoomsView';
import AllBreakoutRoomsContainer, { type AllBreakoutRoomsProps } from '../context/AllBreakoutRoomsContext';
import { getUrlParams } from '../utils/url';

const AllBreakoutRooms = () => {
    const {
        demo,
        token,
        zoom_id: zoomId,
        user_uuid: userId,
        meeting_id: meetingId,
        class_uuid: classId,
        participant_id: participantId,
        breakout_names: breakoutNames = ''
    } = getUrlParams();

    const breakouts = ['Main Classroom', ...breakoutNames.split(',').sort()];

    const props: AllBreakoutRoomsProps = {
        token,
        zoomId,
        userId,
        classId,
        meetingId,
        participantId,
        isDemo: !!demo,
        breakoutNames: breakouts
    };

    return (
        <AllBreakoutRoomsContainer.Provider initialState={props}>
            <AllBreakoutRoomsView />
        </AllBreakoutRoomsContainer.Provider>
    );
};

export default AllBreakoutRooms;
